import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import Invoices from './invoices';

import '../../repi.scss';

class RepiITrade extends React.Component {
    render() {
        const { data } = this.props;

        if (isNullOrUndefined(data))
            return null;
        
        return (
            <div className='repi-payment-history-container'> 
                <Invoices sections={false} data={data} />
            </div>
        );
    }
}

export default connect(
    state => state.report,
    null
)(withLocalize(withRouter(RepiITrade)));